module.exports = __webpack_public_path__ + "img/thumb_up.55ad8064.svg";